<div [formGroup]="form">
  @if (formGroupName) {
  <div class="field-body otherSkills" [formGroupName]="formGroupName" [attr.data-testid]="testIdPrefix + '-form'">
    <p class="rightHeadings" *ngIf="!candidate">
      {{ 'dashboard.createNewJobOffer.candidateOtherH' | translate }}
      <span class="text-danger">*</span>
    </p>
    <div class="flex-column align-items-start">
      <!-- List of added skills -->
      @if (skills.length){
      <div class="inner-form-section w-100" [formGroupName]="controlName">
        @for (skill of skills; track skill; let i = $index){
        <div class="added-items d-flex flex-column justify-content-center align-items-center">
          @if (i >= 1){
          <mat-divider class="w-100"></mat-divider>
          }

          <!-- Display mode -->
          @if(!skill.edit){
          <div class="w-100 lang-content d-flex justify-content-between align-items-center">
            <div class="d-flex flex-column align-items-start w-15">
              <p class="mb-0">{{ 'skills.' + skill.skillName | translate }}</p>
              @if (skill.category) {
              <small class="text-muted category-label">{{ getCategoryDisplayName(skill.category) }}</small>
              }
            </div>
            <p class="mb-0">{{ skill.level | translate }}</p>
            <aside>
              <mat-icon (click)="editSkill(i)" class="ml-2 mr-2 mt-1" [attr.data-testid]="testIdPrefix + '-edit-button-' + i">edit</mat-icon>
              <mat-icon (click)="deleteSkill(i)" class="ml-2 mr-2 mt-1" [attr.data-testid]="testIdPrefix + '-delete-button-' + i">delete_forever</mat-icon>
            </aside>
          </div>
          }

          <!-- Edit mode -->
          @if (skill.edit){
          <div class="editItem w-100">
            <div class="field-body fields2 d-flex justify-content-center gap-5 w-100 gap-4 mt-1">
              <div class="select-width">
                <app-skill-selector
                  [allCVOptionsFromDB]="allCVOptionsFromDB"
                  [placeholder]="('stepperForm.skills.skill' | translate) + '*'"
                  [appearance]="'outline'"
                  [cssClass]="'small'"
                  [testId]="testIdPrefix + '-edit-' + i"
                  [initialExpandedCategory]="editingSkillCategory"
                  formControlName="skillName"></app-skill-selector>
              </div>
              <div class="select-width">
                <mat-form-field appearance="outline" class="small" [attr.data-testid]="testIdPrefix + '-level-select-' + i">
                  <mat-select placeholder="Level*" formControlName="level" matNativeControl required [attr.data-testid]="testIdPrefix + '-level-' + i">
                    @for (item of allCVOptionsFromDB?.skillLevels; track item){
                    <mat-option [value]="item">
                      {{ item | translate }}
                    </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="edit-nav d-flex justify-content-center gap-5" [attr.data-testid]="testIdPrefix + '-edit-actions-' + i">
              <button
                mat-flat-button
                type="button"
                (click)="closeEditSkill(i)"
                class="close p-btn-gray mx-1 small"
                [attr.data-testid]="testIdPrefix + '-edit-close-button-' + i">
                {{ 'shared.close' | translate }}
              </button>
              <button
                mat-flat-button
                type="button"
                (click)="saveEditSkill(i)"
                [disabled]="!form.get((formGroupName ? formGroupName + '.' : '') + controlName)?.valid"
                [ngClass]="form.get((formGroupName ? formGroupName + '.' : '') + controlName)?.valid ? 'valid-submit-button' : ''"
                class="save p-btn-light"
                [attr.data-testid]="testIdPrefix + '-edit-save-button-' + i">
                {{ 'shared.save' | translate }}
              </button>
              <mat-icon (click)="deleteSkill(i)" class="ml-2 mr-2 mt-1" [attr.data-testid]="testIdPrefix + '-edit-delete-button-' + i">delete_forever</mat-icon>
            </div>
          </div>
          }
        </div>
        }
      </div>
      }

      <!-- Add new skill form -->
      <div [formGroupName]="controlName">
        @if (tempNewSkill){
        <div class="inner-card-section">
          <div class="field-body fields2 d-flex justify-content-center gap-5 w-100 gap-4 mt-1">
            <div class="select-width">
              <app-skill-selector
                [allCVOptionsFromDB]="allCVOptionsFromDB"
                [placeholder]="('stepperForm.skills.skill' | translate) + '*'"
                [appearance]="'outline'"
                [cssClass]="'small ' + (skills.length > 0 ? 'mt-4' : '')"
                [testId]="testIdPrefix + '-new'"
                formControlName="skillName"></app-skill-selector>
            </div>
            <div class="select-width">
              <mat-form-field
                appearance="outline"
                class="second-btn small"
                [ngClass]="skills.length > 0 ? 'mt-4' : ''"
                [attr.data-testid]="testIdPrefix + '-level-new-select'">
                <mat-select placeholder="Level*" formControlName="level" matNativeControl required [attr.data-testid]="testIdPrefix + '-level-new'">
                  @for (item of allCVOptionsFromDB?.skillLevels; track item){
                  <mat-option [value]="item">
                    {{ item | translate }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="new-item-nav d-flex justify-content-center gap-5" [attr.data-testid]="testIdPrefix + '-new-actions'">
            <button
              mat-flat-button
              type="button"
              (click)="closeCreateNewSkill()"
              class="close p-btn-gray mx-1 small"
              [attr.data-testid]="testIdPrefix + '-new-close-button'">
              {{ 'shared.close' | translate }}
            </button>
            <button
              mat-flat-button
              type="button"
              (click)="saveNewSkill()"
              [disabled]="!form.get((formGroupName ? formGroupName + '.' : '') + controlName)?.valid"
              [ngClass]="form.get((formGroupName ? formGroupName + '.' : '') + controlName)?.valid ? 'valid-submit-button' : ''"
              class="save p-btn-light"
              [attr.data-testid]="testIdPrefix + '-new-save-button'">
              {{ 'shared.save' | translate }}
            </button>
          </div>
        </div>
        } @if (!tempNewSkill){ @if (candidate) {
        <button (click)="createNewSkill()" class="cursor-pointer addItem p-btn-light" [attr.data-testid]="testIdPrefix + '-add-button'">
          + {{ 'stepperForm.skills.addSkill' | translate }}
        </button>
        } @else {
        <p (click)="createNewSkill()" class="cursor-pointer p-4" [attr.data-testid]="testIdPrefix + '-add-button'">
          + {{ 'stepperForm.skills.addSkill' | translate }}
        </p>
        } }
      </div>
    </div>
  </div>
  } @else {
  <div class="field-body otherSkills" [attr.data-testid]="testIdPrefix + '-form'">
    <p class="rightHeadings" *ngIf="!candidate">
      {{ 'dashboard.createNewJobOffer.candidateOtherH' | translate }}
      <span class="text-danger">*</span>
    </p>
    <div class="flex-column align-items-start">
      <!-- List of added skills -->
      @if (skills.length){
      <div class="inner-form-section w-100" [formGroupName]="controlName">
        @for (skill of skills; track skill; let i = $index){
        <div class="added-items d-flex flex-column justify-content-center align-items-center">
          @if (i >= 1){
          <mat-divider class="w-100"></mat-divider>
          }

          <!-- Display mode -->
          @if(!skill.edit){
          <div class="w-100 lang-content d-flex justify-content-between align-items-center">
            <div class="d-flex flex-column align-items-start w-15">
              <p class="mb-0">{{ 'skills.' + skill.skillName | translate }}</p>
              @if (skill.category) {
              <small class="text-muted category-label">{{ getCategoryDisplayName(skill.category) }}</small>
              }
            </div>
            <p class="mb-0">{{ skill.level | translate }}</p>
            <aside>
              <mat-icon (click)="editSkill(i)" class="ml-2 mr-2 mt-1" [attr.data-testid]="testIdPrefix + '-edit-button-' + i">edit</mat-icon>
              <mat-icon (click)="deleteSkill(i)" class="ml-2 mr-2 mt-1" [attr.data-testid]="testIdPrefix + '-delete-button-' + i">delete_forever</mat-icon>
            </aside>
          </div>
          }

          <!-- Edit mode -->
          @if (skill.edit){
          <div class="editItem w-100">
            <div class="field-body fields2 d-flex justify-content-center gap-5 w-100 gap-4 mt-1">
              <div class="select-width">
                <app-skill-selector
                  [allCVOptionsFromDB]="allCVOptionsFromDB"
                  [placeholder]="('stepperForm.skills.skill' | translate) + '*'"
                  [appearance]="'outline'"
                  [cssClass]="'small'"
                  [testId]="testIdPrefix + '-edit-' + i"
                  [initialExpandedCategory]="editingSkillCategory"
                  formControlName="skillName"></app-skill-selector>
              </div>
              <div class="select-width">
                <mat-form-field appearance="outline" class="small" [attr.data-testid]="testIdPrefix + '-level-select-' + i">
                  <mat-select placeholder="Level*" formControlName="level" matNativeControl required [attr.data-testid]="testIdPrefix + '-level-' + i">
                    @for (item of allCVOptionsFromDB?.skillLevels; track item){
                    <mat-option [value]="item">
                      {{ item | translate }}
                    </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="edit-nav d-flex justify-content-center gap-5" [attr.data-testid]="testIdPrefix + '-edit-actions-' + i">
              <button
                mat-flat-button
                type="button"
                (click)="closeEditSkill(i)"
                class="close p-btn-gray mx-1 small"
                [attr.data-testid]="testIdPrefix + '-edit-close-button-' + i">
                {{ 'shared.close' | translate }}
              </button>
              <button
                mat-flat-button
                type="button"
                (click)="saveEditSkill(i)"
                [disabled]="!form.get(controlName)?.valid"
                [ngClass]="form.get(controlName)?.valid ? 'valid-submit-button' : ''"
                class="save p-btn-light"
                [attr.data-testid]="testIdPrefix + '-edit-save-button-' + i">
                {{ 'shared.save' | translate }}
              </button>
              <mat-icon (click)="deleteSkill(i)" class="ml-2 mr-2 mt-1" [attr.data-testid]="testIdPrefix + '-edit-delete-button-' + i">delete_forever</mat-icon>
            </div>
          </div>
          }
        </div>
        }
      </div>
      }

      <!-- Add new skill form -->
      <div [formGroupName]="controlName">
        @if (tempNewSkill){
        <div class="inner-card-section">
          <div class="field-body fields2 d-flex justify-content-center gap-5 w-100 gap-4 mt-1">
            <div class="select-width">
              <app-skill-selector
                [allCVOptionsFromDB]="allCVOptionsFromDB"
                [placeholder]="('stepperForm.skills.skill' | translate) + '*'"
                [appearance]="'outline'"
                [cssClass]="'small ' + (skills.length > 0 ? 'mt-4' : '')"
                [testId]="testIdPrefix + '-new'"
                formControlName="skillName"></app-skill-selector>
            </div>
            <div class="select-width">
              <mat-form-field
                appearance="outline"
                class="second-btn small"
                [ngClass]="skills.length > 0 ? 'mt-4' : ''"
                [attr.data-testid]="testIdPrefix + '-level-new-select'">
                <mat-select placeholder="Level*" formControlName="level" matNativeControl required [attr.data-testid]="testIdPrefix + '-level-new'">
                  @for (item of allCVOptionsFromDB?.skillLevels; track item){
                  <mat-option [value]="item">
                    {{ item | translate }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="new-item-nav d-flex justify-content-center gap-5" [attr.data-testid]="testIdPrefix + '-new-actions'">
            <button
              mat-flat-button
              type="button"
              (click)="closeCreateNewSkill()"
              class="close p-btn-gray mx-1 small"
              [attr.data-testid]="testIdPrefix + '-new-close-button'">
              {{ 'shared.close' | translate }}
            </button>
            <button
              mat-flat-button
              type="button"
              (click)="saveNewSkill()"
              [disabled]="!form.get(controlName)?.valid"
              [ngClass]="form.get(controlName)?.valid ? 'valid-submit-button' : ''"
              class="save p-btn-light"
              [attr.data-testid]="testIdPrefix + '-new-save-button'">
              {{ 'shared.save' | translate }}
            </button>
          </div>
        </div>
        } @if (!tempNewSkill){ @if (candidate) {
        <button (click)="createNewSkill()" class="cursor-pointer addItem p-btn-light" [attr.data-testid]="testIdPrefix + '-add-button'">
          + {{ 'stepperForm.skills.addSkill' | translate }}
        </button>
        } @else {
        <p (click)="createNewSkill()" class="cursor-pointer p-4" [attr.data-testid]="testIdPrefix + '-add-button'">
          + {{ 'stepperForm.skills.addSkill' | translate }}
        </p>
        } }
      </div>
    </div>
  </div>
  }
</div>
